import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { toast } from 'material-react-toastify';
import {
  Box,
  Button,
  Divider,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { Product } from '../../../../interfaces/Product/Product';
import { updateProductSlug } from '../../../../api/Product';
import { sharedStyles } from '../../../../utils/Style';
import { Waiting } from '../../../../components/Waiting/Waiting';

interface UpdateProductSlugProps {
  initialValue?: Product;
  onSave: () => void;
}

export const UpdateProductSlug = (props: UpdateProductSlugProps) => {
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setValue(props.initialValue?.slug ?? '');
  }, [props.initialValue]);

  const handleSave = () => {
    if (!props.initialValue) {
      return;
    }

    setLoading(true);
    updateProductSlug(props.initialValue.id, value)
      .then(() => {
        toast.success("Ürün URL'i başarıyla güncellendi");
        props.onSave();
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  const isValid = !isEmpty(value);

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        p: 3,
        width: 450,
        height: 'fit-content',
      }}
    >
      <Waiting open={loading} />

      <Typography
        sx={{
          ...sharedStyles.h5,
          fontWeight: 'bold',
        }}
      >
        URL
      </Typography>
      <Divider />

      <TextField
        variant='outlined'
        size='small'
        disabled={!props.initialValue}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        error={!isValid}
        fullWidth
      />

      <Box
        sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}
      >
        <Button
          variant='contained'
          disabled={!isValid}
          onClick={handleSave}
          sx={{ ...sharedStyles.buttonText }}
        >
          Kaydet
        </Button>
      </Box>
    </Paper>
  );
};
